<template>
  <div class="ico-list-model">
    <div class="ico-list-title">
        <h2>{{ title }}</h2> 
    </div>
    <div :hidden="!ListInfo" class="ico-list">
        <div class="ico-list-content">
            <div class="ico-item" v-for="(it, index) in ListInfo" :key="index" v-show="it.value"> 
                <!-- <div :hidden="true" class="ico-item-ico"> 
                  <i :class="it.ico"></i>
                </div>   -->
                <div class="ico-item-line" > 
                  <i :class="['iconfont', it.ico]"></i> 
                </div > 
                <div  class="ico-item-text">{{it.label}}: {{ it.value }}</div> 
            </div>
        </div> 
    </div> 
    <div :hidden="!QRCode" class="QR-Code">
        <img :src="QRCode" :alt="title" />
    </div>
  </div> 
  
</template>

<script>
export default {
  name: 'IcoListModel',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Default Title'
    },
    ListInfo: {
      type:Array 
    },
    QRCode: {
      type:String
    } 
  },
  data(){
    return{
      linesrc:require('@/assets/btn_nav/line_a.png')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/iconfont/iconfont.css';
@media screen  and (max-width: 767px)and (min-width: 0px) {
  .QR-Code{
    img{ 
      max-width: 280px;
    }
  }
}
.QR-Code{
    position: relative;
    height: 100%;
    width: 100%;
    img{ 
      max-width: 320px;
      height: auto;
    }
}
.ico-list-model{
    position: relative;
    .ico-list-title{
        margin-right: 10px;
        margin-bottom: 20px;
        margin-top: 40px;
        font-weight: bold;
        background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent;
    }
    .ico-list{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        .ico-list-content{
            position: relative;
            height: 100%;
            widows: 100%;
            .ico-item{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: left;
                height: 2.5rem;
                color: #dfc680; 
                .ico-item-ico{
                    font-size: 27px;
                    width: 50px;
                }
                .ico-item-line{
                  font-size: 27px!important;
                  width: 50px; 
                }
                .ico-item-text{
                    font-size: 22px;
                    font-weight: bold;
                    color: #fbedcd;
                }
            }
        }
        
       
    }
}

</style>